// tslint:disable:member-ordering
export class ApiLinks {
  private static readonly cuttingApi: string = '/api-cutting/';
  private static readonly api: string = '/api/';

  /* MATERIAL */
  private static readonly _material: string = 'material';
  private static readonly _materialBase: string = 'material-base';
  private static readonly _materialGroup: string = 'material-groups';
  private static readonly _operationGroups: string = 'operation-groups';
  private static readonly _operations: string = 'operation-list';
  private static readonly _csv2panels: string = 'panels/parse-csv';
  private static readonly _panels2csv: string = 'panels/export-to-csv';
  private static readonly _butt: string = 'butt';
  private static readonly _buttsThickneses: string = 'butts-thickneses';
  private static readonly _matchedButts: string = 'matched-butts';
  private static readonly _grooves: string = 'grooves';
  private static readonly _groovesUsed: string = 'used';
  private static readonly _customGrooveOptions: string = 'custom-groove-options';
  private static readonly _customGrooveSchemas: string = 'custom-groove-schemas';
  private static readonly _materialTexture: string = 'texture';
  private static readonly _furniture: string = 'furniture';
  private static readonly _matBaseFurniture: string = 'mb-furniture';
  private static readonly _matBaseFurnitureGroup: string = 'group/furniture';
  // cutouts
  private static readonly _cuttingStandardCutouts: string = 'standard-cutouts';

  static get cuttingStandardCutouts(): string {
    return `${this.cuttingApi + this._cuttingStandardCutouts}`;
  }

  static get availableSlotsStandardCutouts(): string {
    return `${this.cuttingApi + this._cuttingStandardCutouts}/available-slots`;
  }

  static get material(): string {
    return this.cuttingApi + this._material;
  }
  static get materialGroup(): string {
    return this.cuttingApi + this._materialBase + '/' + this._materialGroup;
  }
  static get materialBase(): string {
    return this.cuttingApi + this._materialBase;
  }
  static get operationGroups(): string {
    return this.materialBase + '/' + this._operationGroups;
  }
  static get operationList(): string {
    return this.materialBase + '/' + this._operations;
  }
  static get measures(): string {
    return this.materialBase + '/measure';
  }
  static get materialTexture(): string {
    return this.cuttingApi + this._material + '/' + this._materialTexture;
  }
  static get grooves(): string {
    return `${this.cuttingApi + this._material}/${this._grooves}`;
  }
  static get groovesUsed(): string {
    return `${this.cuttingApi + this._material}/${this._grooves}/${this._groovesUsed}`;
  }
  static get customGrooveOptions(): string {
    return `${this.cuttingApi + this._material}/${this._grooves}/${this._customGrooveOptions}`;
  }
  static get customGrooveSchemas(): string {
    return `${this.cuttingApi + this._material}/${this._grooves}/${this._customGrooveSchemas}`;
  }
  static get butt(): string {
    return this.cuttingApi + this._material + '/' + this._butt;
  }
  static get buttsThickneses(): string {
    return this.cuttingApi + this._material + '/' + this._buttsThickneses;
  }
  static get matchedButts(): string {
    return this.cuttingApi + this._material + '/' + this._matchedButts;
  }
  static get csv2panels(): string {
    return `${this.cuttingApi + this._material}/${this._csv2panels}`;
  }
  static panels2csvForClient(materialId: number): string {
    return `${this.cuttingApi + this._material}/${materialId.toString()}/${this._panels2csv}`;
  }
  static get matBaseFurniture(): string {
    return this.cuttingApi + this._furniture + '/' + this._matBaseFurniture;
  }
  static get matBaseFurnitureGroup(): string {
    return this.cuttingApi + this._furniture + '/' + this._matBaseFurnitureGroup;
  }

  /* CLIENT */
  private static readonly _client: string = 'client';
  private static readonly _clientOptions: string = 'client/client-options';
  private static readonly _CuttingSettingsC: string = 'cutting-settings';

  static get cuttingSettingsC(): string {
    return `${this.cuttingApi + this._client}/${this._CuttingSettingsC}`;
  }
  static get clientOptions(): string {
    return this.cuttingApi + this._clientOptions;
  }

  /* CUTTING SETTINGS */
  private static readonly _cuttingSettingsU: string = 'cutting-settings';
  static get cuttingSettingsU(): string {
    return `${this.api + this._cuttingSettingsU}`;
  }

  /* ORDER */
  private static readonly _orderAttachmentsC: string = 'order-attachments';
  private static readonly _orderAttachmentsU: string = 'cutting-order-attachments';
  private static readonly _orderOrdersU: string = 'cutting-orders';
  private static readonly _downloadOrderAttachmentsU: string = 'file';

  static panels2csvForUser(orderId: number, materialId: number): string {
    return `${this.api + this._orderOrdersU}/${orderId}/materials/${materialId}/${this._panels2csv}`;
  }
  static orderAttachmentsU(orderId: number): string {
    return `${this.api + this._orderAttachmentsU}/${orderId}`;
  }
  static orderAttachmentsC(orderId: number): string {
    return this.cuttingApi + this._orderAttachmentsC + '/' + orderId;
  }
  static downloadOrderAttachmentsU(orderId: number, fileId: number): string {
    return `${this.api + this._orderAttachmentsU}/${orderId}/${this._downloadOrderAttachmentsU}/${fileId}`;
  }

  /* FASTENERS */
  private static readonly _fasteners: string = 'fasteners-set';
  private static readonly _holeSchema: string = 'hole-schema';
  private static readonly _fastenersSetIcon: string = 'icon';

  static get customHoleSchemas(): string {
    return `${this.cuttingApi}fasteners/${this._holeSchema}`;
  }
  static get fastenersSet(): string {
    return `${this.cuttingApi + 'fasteners/' + this._fasteners}`;
  }
  static fastenersSetIcon(id: number): string {
    return `${this.cuttingApi + 'fasteners/' + this._fasteners}/${id}/${this._fastenersSetIcon}`;
  }

  /* MILLINGS */
  private static readonly _millings: string = 'milling';

  static get millingsForClient(): string {
    return this.cuttingApi + this._millings;
  }

  /* FACADES */
  private static readonly _orderFacade: string = 'facades';

  static get orderFacade(): string {
    return `${this.cuttingApi + this._orderFacade}`;
  }

  /* COUNTERTOPS */
  private static readonly _orderCountertop: string = 'countertops';

  static get orderCountertop(): string {
    return `${this.cuttingApi + this._orderCountertop}`;
  }

  /* CSV SCHEMAS */
  private static readonly _csvSchemas: string = 'csv-schemas';

  static get csvSchemas(): string {
    return `${this.cuttingApi + this._csvSchemas}`;
  }
}
